export default __webpack_public_path__ + "static/media/Instagram.994005be.svg";